import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import save from "../../../../../assets/images/save.svg";
import DriverFormWrapper from "./DriverForm.styles";
import {Formik} from 'formik';
import {Dropdown} from "primereact/dropdown";
import * as globalUtils from "../../../../../helpers/utils";

const DriverForm = ({width, onCloseClick, onSubmit}) => {
    const dates = globalUtils.getGregYearOfBirthList()
    return (
        <DriverFormWrapper>
            <div className="driver-info-container-missing-info">
                {width >= 768 ? <hr/> : null}
                <h4 className="otherInfoSubTitle">Driver Details</h4>
                <p>Please complete the missing information</p>
                <Formik
                    initialValues={{idNumber: '', yearOfBirth: ''}}
                    validate={values => {
                        const errors = {};
                        if (!values?.idNumber) {
                            errors.idNumber = 'Required';
                        }
                        if (!values?.yearOfBirth) {
                            errors.yearOfBirth = "Required";
                        }
                        return errors;
                    }}
                    onSubmit={(values, {setSubmitting}) => {
                        onSubmit(values);
                        setSubmitting(false);
                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          isSubmitting
                      }) => (
                        <>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-6 columnpolicy py-2">
                                        <div className="input-wrapper">
                                            <i className="pi pi-credit-card"/>
                                            <InputText className="input-control"
                                                       name="idNumber"
                                                       value={values.idNumber}
                                                       onChange={handleChange('idNumber')}
                                                       onBlur={handleBlur('idNumber')}
                                                       placeholder={'ID Number'}/>
                                            {touched.idNumber && <span className="text-danger">{errors.idNumber}</span>}
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-12 col-lg-6 columnpolicy py-2">
                                        <div className="input-wrapper">
                                            <i className="pi pi-calendar"/>
                                            <Dropdown
                                                className={"w-100 border-0 input-control"}
                                                inputId="yearOfBirth"
                                                value={values.yearOfBirth}
                                                options={dates}
                                                onChange={handleChange('yearOfBirth')}
                                                onBlur={handleBlur('yearOfBirth')}
                                                optionLabel="label"
                                            />
                                            {touched.yearOfBirth &&
                                                <span className="text-danger">{errors.yearOfBirth}</span>}
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="driver-info-container-edit-options">
                                    <Button
                                        className="button-clear"
                                        onClick={onCloseClick}
                                        label="Close">
                                    </Button>
                                    <Button
                                        className="driver-info-container-edit-options-save"
                                        type={"submit"}
                                        disabled={isSubmitting}
                                        label="Save">
                                        <img
                                            src={save}
                                            alt="Save"
                                            className="driver-info-container-edit-options-save img"
                                        />
                                    </Button>
                                </div>
                            </form>
                        </>
                    )}
                </Formik>
            </div>
        </DriverFormWrapper>
    )
}

export default DriverForm;